import { render, staticRenderFns } from "./PagoInscripcionCard.vue?vue&type=template&id=396b37d9&scoped=true"
import script from "./PagoInscripcionCard.vue?vue&type=script&lang=js"
export * from "./PagoInscripcionCard.vue?vue&type=script&lang=js"
import style0 from "./PagoInscripcionCard.vue?vue&type=style&index=0&id=396b37d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b37d9",
  null
  
)

export default component.exports